import { User, HandHeart, Compass, Recycle, UtensilsCrossed, Users } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";

const FEATURES = [
  {
    icon: User,
    title: "Personalized",
    desc: "Coaching built around the individual rather than a one-size-fits-all plan.",
  },
  {
    icon: HandHeart,
    title: "Supportive",
    desc: "A positive environment where you feel comfortable, welcome and encouraged.",
  },
  {
    icon: Compass,
    title: "Accountability",
    desc: "Consistent encouragement and guidance to help you stay on track.",
  },
  {
    icon: Recycle,
    title: "Sustainable",
    desc: "Realistic habits designed to become part of your everyday life.",
  },
  {
    icon: UtensilsCrossed,
    title: "Fitness + Nutrition",
    desc: "Movement and nutrition together for a more complete approach to wellness.",
  },
  {
    icon: Users,
    title: "Community",
    desc: "Connection and motivation through group fitness and coaching.",
  },
];

const WhyUs = () => (
  <section id="why" className="relative py-24 sm:py-32 bg-charcoal grain overflow-hidden" data-testid="why-section">
    <div
      aria-hidden="true"
      className="absolute -top-40 right-0 w-[30rem] h-[30rem] rounded-full bg-brand/10 blur-3xl"
    />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHeading
        number="04"
        label="Why Me 1st"
        title="Because You Deserve to Put Yourself First."
        dark
      />
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {FEATURES.map((f, i) => (
          <Reveal key={f.title} delay={0.06 * i}>
            <article
              className="group h-full rounded-3xl border border-sand/10 bg-sand/[0.04] p-8 transition-colors duration-500 hover:border-brand/60 hover:bg-sand/[0.07]"
              data-testid={`why-card-${i}`}
            >
              <span className="w-12 h-12 rounded-full bg-brand/15 flex items-center justify-center">
                <f.icon size={22} className="text-brand" />
              </span>
              <h3 className="font-display text-2xl font-bold tracking-tight text-sand mt-6">
                {f.title}
              </h3>
              <p className="mt-3 text-sand/60 leading-relaxed">{f.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
